var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "v-row",
          [
            _c("v-col", { staticClass: "ta-r", attrs: { cols: "12" } }, [
              _c("img", {
                staticClass: "pr-4 pt-4",
                attrs: { src: _vm.ic_afs_logo },
              }),
            ]),
            _c(
              "v-col",
              {
                class: { "mt-n16": _vm.xs },
                attrs: {
                  cols: "12",
                  xl: "6",
                  lg: "6",
                  md: "6",
                  sm: "12",
                  order: "2",
                  "order-xl": "1",
                  "order-lg": "1",
                  "order-md": "1",
                  "order-sm": "2",
                },
              },
              [
                _c(
                  "v-row",
                  { attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "8" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c("v-col", { attrs: { cols: "12" } }, [
                              _c("img", {
                                attrs: { src: _vm.ic_tms_logo, width: "120" },
                              }),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", { attrs: { cols: "12" } }, [
                              _c("label", { staticClass: "main-header" }, [
                                _vm._v("Register your profile"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-n4" },
                          [
                            _c("v-col", { attrs: { cols: "12" } }, [
                              _c("label", { staticClass: "text" }, [
                                _vm._v("Already have a profile?"),
                              ]),
                              _c(
                                "label",
                                {
                                  staticClass: "login-lnk hover",
                                  on: { click: _vm.login },
                                },
                                [_vm._v("Log In")]
                              ),
                              _c("label", { staticClass: "text" }, [
                                _vm._v("."),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-6" },
                          [
                            _c("v-col", { attrs: { cols: "12" } }, [
                              _c("label", { staticClass: "contact-info" }, [
                                _vm._v("Contact Information"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    height: "42px",
                                    items: _vm.prefixTypes,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("label", [_vm._v("Prefix")])]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.request.prefix,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "prefix", $$v)
                                    },
                                    expression: "request.prefix",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n6",
                                class: { "pr-2": _vm.mdAndUp },
                                attrs: {
                                  cols: "12",
                                  xl: "6",
                                  lg: "6",
                                  md: "6",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "First Name",
                                    maxlength: 32,
                                    required: true,
                                    "show-details": true,
                                  },
                                  model: {
                                    value: _vm.request.firstName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "firstName", $$v)
                                    },
                                    expression: "request.firstName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n6",
                                class: { "pl-2": _vm.mdAndUp },
                                attrs: {
                                  cols: "12",
                                  xl: "6",
                                  lg: "6",
                                  md: "6",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Last Name",
                                    maxlength: 32,
                                    required: true,
                                    "show-details": true,
                                  },
                                  model: {
                                    value: _vm.request.lastName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "lastName", $$v)
                                    },
                                    expression: "request.lastName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { staticClass: "mt-n6", attrs: { cols: "12" } },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Email",
                                    maxlength: 50,
                                    required: true,
                                    "show-details": true,
                                    email: true,
                                  },
                                  model: {
                                    value: _vm.request.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "email", $$v)
                                    },
                                    expression: "request.email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n6",
                                class: { "pr-2": _vm.mdAndUp },
                                attrs: {
                                  cols: "12",
                                  xl: "9",
                                  lg: "9",
                                  md: "9",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Phone",
                                    required: true,
                                    "show-details": true,
                                    phone: true,
                                  },
                                  model: {
                                    value: _vm.phoneFormatted,
                                    callback: function ($$v) {
                                      _vm.phoneFormatted = $$v
                                    },
                                    expression: "phoneFormatted",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "mt-n6",
                                class: { "pl-2": _vm.mdAndUp },
                                attrs: {
                                  cols: "12",
                                  xl: "3",
                                  lg: "3",
                                  md: "3",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Ext.",
                                    maxlength: 5,
                                    number: true,
                                  },
                                  model: {
                                    value: _vm.request.ext,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "ext", $$v)
                                    },
                                    expression: "request.ext",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                class: {
                                  "pr-2 mt-n6": _vm.mdAndUp,
                                  "mt-0": _vm.smAndDown,
                                },
                                attrs: {
                                  cols: "12",
                                  xl: "6",
                                  lg: "6",
                                  md: "6",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Create Password",
                                    password: true,
                                  },
                                  model: {
                                    value: _vm.request.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "password", $$v)
                                    },
                                    expression: "request.password",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                class: {
                                  "pl-2 mt-n6": _vm.mdAndUp,
                                  "mt-0": _vm.smAndDown,
                                },
                                attrs: {
                                  cols: "12",
                                  xl: "6",
                                  lg: "6",
                                  md: "6",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Confirm Password",
                                    password: true,
                                  },
                                  model: {
                                    value: _vm.request.confirmPassword,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.request,
                                        "confirmPassword",
                                        $$v
                                      )
                                    },
                                    expression: "request.confirmPassword",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.weakPassword
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "red--text text--darken-1 weak-password",
                                      },
                                      [
                                        _vm._v(
                                          "Password must be between 10 and 15 characters long, including lowercase, uppercase, numbers, and special characters."
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.matchPasswords
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "red--text text--darken-1 weak-password",
                                      },
                                      [_vm._v("Passwords do not match.")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-2" },
                          [
                            _c("v-col", { attrs: { cols: "12" } }, [
                              _c("label", { staticClass: "contact-info" }, [
                                _vm._v("Location Information"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-2" },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Company Name",
                                    maxlength: "150",
                                  },
                                  model: {
                                    value: _vm.request.companyName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "companyName", $$v)
                                    },
                                    expression: "request.companyName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("smart-combobox", {
                                  attrs: {
                                    items: _vm.countriesDll,
                                    required: true,
                                    "hide-details": false,
                                    label: "Country",
                                    clearable: "",
                                  },
                                  on: { change: _vm.countryChanged },
                                  model: {
                                    value: _vm.selectedCountry,
                                    callback: function ($$v) {
                                      _vm.selectedCountry = $$v
                                    },
                                    expression: "selectedCountry",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-n6" },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Address",
                                    "show-details": true,
                                    required: true,
                                  },
                                  model: {
                                    value: _vm.request.address,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "address", $$v)
                                    },
                                    expression: "request.address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-n6" },
                          [
                            _c(
                              "v-col",
                              {
                                class: {
                                  "pr-2": _vm.mdAndUp,
                                  "pb-0": _vm.smAndDown,
                                },
                                attrs: {
                                  cols: "12",
                                  xl: "7",
                                  lg: "7",
                                  md: "7",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "City",
                                    "show-details": true,
                                    required: true,
                                  },
                                  model: {
                                    value: _vm.request.city,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "city", $$v)
                                    },
                                    expression: "request.city",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                class: {
                                  "pl-2": _vm.mdAndUp,
                                  "pt-0": _vm.smAndDown,
                                },
                                attrs: {
                                  cols: "12",
                                  xl: "5",
                                  lg: "5",
                                  md: "5",
                                  sm: "12",
                                },
                              },
                              [
                                _c("smart-combobox", {
                                  attrs: {
                                    items: _vm.statesDdl,
                                    label: "State",
                                    clearable: "",
                                    rules: _vm.stateRules,
                                  },
                                  on: { change: _vm.stateChanged },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c("label", [_vm._v("State")]),
                                          _c(
                                            "label",
                                            { staticClass: "red-lbl" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.selectedState,
                                    callback: function ($$v) {
                                      _vm.selectedState = $$v
                                    },
                                    expression: "selectedState",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-n6" },
                          [
                            _c(
                              "v-col",
                              {
                                class: { "mt-6": _vm.smAndDown },
                                attrs: { cols: "12" },
                              },
                              [
                                _c("smart-text-field", {
                                  attrs: {
                                    placeholder: "Zip/Postal Code",
                                    "show-details": true,
                                    required: true,
                                    maxlength: "9",
                                  },
                                  model: {
                                    value: _vm.request.postalCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.request, "postalCode", $$v)
                                    },
                                    expression: "request.postalCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-n8" },
                          [
                            _c("v-col", { attrs: { cols: "12" } }, [
                              _c("label", { staticClass: "text-gray" }, [
                                _vm._v("By registering, you agree to AFS’s "),
                              ]),
                              _c(
                                "a",
                                {
                                  staticClass: "text-blue hover",
                                  attrs: {
                                    target: "_blank",
                                    href: "https://afs.net/terms-and-conditions",
                                  },
                                },
                                [_vm._v("Terms of Service")]
                              ),
                              _c("label", { staticClass: "text-gray" }, [
                                _vm._v(" and "),
                              ]),
                              _c(
                                "a",
                                {
                                  staticClass: "text-blue hover",
                                  attrs: {
                                    target: "_blank",
                                    href: "https://afs.net/privacy-policy",
                                  },
                                },
                                [_vm._v("Privacy Policy")]
                              ),
                              _c("label", { staticClass: "text-gray" }, [
                                _vm._v("."),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mb-8 mt-6" },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("smart-btn", {
                                  staticClass: "fr mt-1 w-105",
                                  class: { "opacity-05": !_vm.canSave },
                                  attrs: {
                                    type: "primary",
                                    label: "Register",
                                    width: "137",
                                    height: "56",
                                    "font-size": "13",
                                    ripple: _vm.canSave,
                                  },
                                  on: { click: _vm.register },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-col",
              {
                class: { "mt-n16": _vm.md },
                attrs: {
                  cols: "12",
                  xl: "6",
                  lg: "6",
                  md: "6",
                  sm: "12",
                  order: "1",
                  "order-xl": "2",
                  "order-lg": "2",
                  "order-md": "2",
                  "order-sm": "1",
                },
              },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "image-container",
                    attrs: { justify: "center", align: "center" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ta-c flex-center",
                        attrs: { cols: "12" },
                      },
                      [
                        _c("label", { staticClass: "instant-quote-lbl" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.notXs
                                  ? "Instantly quote, book, and manage your shipments all on one platform"
                                  : "Quote, book, and manage your shipments"
                              ) +
                              ". "
                          ),
                        ]),
                        _vm.notXs
                          ? _c("div", { staticClass: "devices" }, [
                              _c("img", { attrs: { src: _vm.ic_devices } }),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "v-overlay",
          {
            attrs: {
              value: _vm.showLoadingScreen,
              opacity: "0.9",
              color: "#fff",
            },
          },
          [
            _c(
              "v-row",
              { staticClass: "mt-n16" },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "text-center",
                    class: { "px-6": _vm.smAndDown },
                  },
                  [
                    !_vm.created
                      ? _c("img", {
                          staticClass: "rotating",
                          attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                        })
                      : _vm._e(),
                    _vm.created
                      ? _c("img", {
                          attrs: { src: require("@/assets/images/rocket.svg") },
                        })
                      : _vm._e(),
                    _c("p", { staticClass: "overlay-txt mt-5" }, [
                      _vm._v(" " + _vm._s(_vm.loadingScreenMessage) + " "),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "v-snackbar",
          {
            model: {
              value: _vm.snackbar,
              callback: function ($$v) {
                _vm.snackbar = $$v
              },
              expression: "snackbar",
            },
          },
          [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
        ),
        _c(
          "v-snackbar",
          {
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function (ref) {
                  var attrs = ref.attrs
                  return [
                    _c(
                      "v-btn",
                      _vm._b(
                        {
                          attrs: { color: "#007BFF", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.snackbarError = false
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      [_vm._v(" Close ")]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.snackbarError,
              callback: function ($$v) {
                _vm.snackbarError = $$v
              },
              expression: "snackbarError",
            },
          },
          [
            _c("img", {
              staticClass: "success-icon",
              attrs: { src: _vm.ic_warning_orange },
            }),
            _vm._v(" " + _vm._s(_vm.snackbarErrorText) + " "),
          ]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "bg" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }